import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { PerfilService } from '../../../shared/services/apis/usuario/perfil.service';
import { PerfilRequest } from '../../../shared/services/requests/usuario/perfil.request';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ModuloPerfilService } from '../../../shared/services/apis/usuario/modulo-perfil.service';
import { ListaModuloPerfilResponse } from '../../../shared/services/responses/usuario/lista-modulo-perfil.response';
import { ModuloPerfilStruct } from '../../../shared/services/structs/usuario/modulo-perfil.struct';
import { FuncionalidadeStruct } from '../../../shared/services/structs/usuario/funcionalidade.struct';
import { PermissaoStruct } from '../../../shared/services/structs/usuario/permissao.struct';
import { MatCheckbox, MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';
import { FooterActionComponent } from '../../../shared/components/footer-action/footer-action.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { AcessoHorario } from '../../../shared/services/models/usuario/acesso-horario.model';

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

export interface HorarioDia {
  diaSemana: number;
  nome: string;
  habilitado: boolean;
  intervalos: HorarioIntervalo[];
}

export interface HorarioIntervalo {
  horaInicio: string;
  horaFim: string;
}

@Component({
  selector: 'app-perfil-cadastro',
  imports: [
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    MatSlideToggleModule,
    CdkAccordionModule,
    MatCheckboxModule,
    FooterActionComponent,
    HeaderComponent
  ],
  providers: [MatCheckbox, MatCheckboxChange],
  templateUrl: './perfil-cadastro.component.html',
  styleUrl: './perfil-cadastro.component.css',
})
export class PerfilCadastroComponent implements OnInit {
  expandedIndex: number = 0;
  moduloEnum: ModuloEnum = ModuloEnum.Configuracoes;
  funcionalidadeEnum: FuncionalidadeEnum = FuncionalidadeEnum.Configuracoes_Perfil;
  model: FormGroup;
  _isLoading: boolean = false;
  isFirstLoading: boolean;
  isUpdate: boolean;
  listaModuloPerfil: Array<ModuloPerfilStruct> = new Array<ModuloPerfilStruct>();
  idPerfil: number;
  isMaster: boolean;

  // IP Restriction
  listaIpRestrito: string[] = [];
  novoIp: string = '';

  // Schedule Restriction
  listaHorarioPorDia: HorarioDia[] = [
    { diaSemana: 0, nome: 'Domingo', habilitado: false, intervalos: [{ horaInicio: '08:00', horaFim: '18:00' }] },
    { diaSemana: 1, nome: 'Segunda', habilitado: false, intervalos: [{ horaInicio: '08:00', horaFim: '18:00' }] },
    { diaSemana: 2, nome: 'Terça', habilitado: false, intervalos: [{ horaInicio: '08:00', horaFim: '18:00' }] },
    { diaSemana: 3, nome: 'Quarta', habilitado: false, intervalos: [{ horaInicio: '08:00', horaFim: '18:00' }] },
    { diaSemana: 4, nome: 'Quinta', habilitado: false, intervalos: [{ horaInicio: '08:00', horaFim: '18:00' }] },
    { diaSemana: 5, nome: 'Sexta', habilitado: false, intervalos: [{ horaInicio: '08:00', horaFim: '18:00' }] },
    { diaSemana: 6, nome: 'Sábado', habilitado: false, intervalos: [{ horaInicio: '08:00', horaFim: '18:00' }] },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private perfilService: PerfilService,
    private moduloPerfilService: ModuloPerfilService,
    public dialog: MatDialog,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.isMaster = this.authService.getUserInfos().master;
    this.model = this.formBuilder.group({
      nome: ['', [Validators.required, requiredTrim]],
      descricao: [''],
    });

    this.isUpdate = false;
    if (this.activatedRoute.snapshot.paramMap.get('idPerfil'))
      this.idPerfil = parseInt(this.activatedRoute.snapshot.paramMap.get('idPerfil') ?? '');

    this.listModule();
  }

  adicionarIp(): void {
    const ip = this.novoIp.trim();
    if (!ip) {
      this.alertService.show('Aviso', 'Informe um endereço IP válido.', AlertType.warning);
      return;
    }
    if (this.listaIpRestrito.includes(ip)) {
      this.alertService.show('Aviso', 'Este IP já foi adicionado.', AlertType.warning);
      return;
    }
    this.listaIpRestrito = [...this.listaIpRestrito, ip];
    this.novoIp = '';
  }

  removerIp(ip: string): void {
    this.listaIpRestrito = this.listaIpRestrito.filter(i => i !== ip);
  }

  get possuiRestricaoHorario(): boolean {
    return this.listaHorarioPorDia.some(d => d.habilitado);
  }

  get possuiRestricaoIp(): boolean {
    return this.listaIpRestrito.length > 0;
  }

  get diasSemana(): HorarioDia[] {
    return this.listaHorarioPorDia.filter(dia => dia.diaSemana >= 1 && dia.diaSemana <= 5);
  }

  get diasFimDeSemana(): HorarioDia[] {
    return this.listaHorarioPorDia.filter(dia => dia.diaSemana === 0 || dia.diaSemana === 6);
  }

  private buildListaAcessoHorario(): AcessoHorario[] {
    return this.listaHorarioPorDia
      .filter(d => d.habilitado)
      .flatMap(d =>
        d.intervalos.map(i => ({
          diaSemana: d.diaSemana,
          horaInicio: this.normalizeTime(i.horaInicio),
          horaFim: this.normalizeTime(i.horaFim),
        }))
      );
  }

  private normalizeTime(value: string): string {
    return (value ?? '').substring(0, 5);
  }

  private buildListaIpRestrito(): string[] {
    return Array.from(new Set(this.listaIpRestrito.map(ip => ip.trim()).filter(ip => ip.length > 0)));
  }

  public onDayToggled(dia: HorarioDia): void {
    if (dia.habilitado) {
      if (!dia.intervalos || dia.intervalos.length === 0) {
        dia.intervalos = [{ horaInicio: '08:00', horaFim: '18:00' }];
      }
    } else {
      // Ao desativar o dia, limpa a lista de horários acumulada — reativar começa do zero.
      dia.intervalos = [{ horaInicio: '08:00', horaFim: '18:00' }];
    }
  }

  public adicionarIntervalo(dia: HorarioDia): void {
    const novo: HorarioIntervalo = { horaInicio: '08:00', horaFim: '18:00' };
    dia.intervalos = [...(dia.intervalos ?? []), novo];
  }

  public removerIntervalo(dia: HorarioDia, index: number): void {
    if (!dia.intervalos || dia.intervalos.length <= 1) return;
    dia.intervalos = dia.intervalos.filter((_, i) => i !== index);
  }

  submit(): void {
    if (this._isLoading) {
      return;
    }

    if (!this.model.valid) {
      this.alertService.show(
        'Erro',
        'Todos os campos em vermelho devem ser corretamente preenchidos.',
        AlertType.error
      );
      return;
    }

    // Validate time ranges
    for (const dia of this.listaHorarioPorDia.filter(d => d.habilitado)) {
      if (!dia.intervalos || dia.intervalos.length === 0) {
        this.alertService.show(
          'Aviso',
          `Adicione ao menos um intervalo de horário para ${dia.nome}.`,
          AlertType.warning
        );
        return;
      }
      for (const intervalo of dia.intervalos) {
        if (intervalo.horaInicio >= intervalo.horaFim) {
          this.alertService.show(
            'Aviso',
            `O horário de início de ${dia.nome} deve ser anterior ao horário de fim.`,
            AlertType.warning
          );
          return;
        }
      }
    }

    this._isLoading = true;
    const permissoesSelecionadas: Array<PermissaoStruct> = this.getSelectedRoles();
    const idsPermissoesSelecionadas: Array<number> = permissoesSelecionadas.map(
      (permissao: PermissaoStruct) => permissao.idPermissao
    );
    const profile: PerfilRequest = {
      descricao: this.model.value.descricao,
      nome: this.model.value.nome,
      listaIdPermissao: idsPermissoesSelecionadas,
      listaIpRestrito: this.buildListaIpRestrito(),
      listaAcessoHorario: this.buildListaAcessoHorario(),
    };
    let profileSubmitProfile;
    if (this.isUpdate) {
      profileSubmitProfile = this.perfilService.Alterar(this.idPerfil, profile);
    } else {
      profileSubmitProfile = this.perfilService.Incluir(profile);
    }

    profileSubmitProfile.subscribe({
      next: response => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this._isLoading = false;
          return;
        }
        this.alertService.show('Sucesso', 'Perfil salvo com sucesso', AlertType.success);
        this._isLoading = false;
        this.router.navigate(['/configuracoes/perfil']);
      },
      error: error => {
        console.log(error);
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });

    return;
  }

  // --- UX de permissões: badge de contagem + seleção em massa por funcionalidade ---
  // Obs: os nomes das permissões não são consistentes entre funcionalidades (algumas usam
  // nomes genéricos como "Alterar", outras já vêm com o nome da funcionalidade embutido,
  // ex. "Entradas e Saídas de Estoque - Alterar") — por isso a seleção em massa é sempre
  // escopada à própria funcionalidade, nunca por "nome de ação" comparado entre linhas.

  getModuloTotal(modulo: ModuloPerfilStruct): number {
    return modulo.listaFuncionalidade.reduce((acc, f) => acc + f.listaPermissao.length, 0);
  }

  getModuloSelecionadas(modulo: ModuloPerfilStruct): number {
    return modulo.listaFuncionalidade.reduce(
      (acc, f) => acc + f.listaPermissao.filter(p => p.selecionado).length,
      0
    );
  }

  isFuncionalidadeTotalmenteMarcada(funcionalidade: FuncionalidadeStruct): boolean {
    return funcionalidade.listaPermissao.length > 0 && funcionalidade.listaPermissao.every(p => p.selecionado);
  }

  toggleFuncionalidadeEmMassa(funcionalidade: FuncionalidadeStruct): void {
    const marcarTudo = !this.isFuncionalidadeTotalmenteMarcada(funcionalidade);
    funcionalidade.listaPermissao.forEach(p => (p.selecionado = marcarTudo));
  }

  // Alguns nomes de permissão já vêm compostos (ex.: "Entradas e Saídas de Estoque - Alterar").
  // Separar visualmente o prefixo (o quê) da ação (verbo) ajuda a escanear listas longas e mistas.
  parsePermissaoNome(nome: string): { prefixo: string | null; acao: string } {
    const idx = nome.lastIndexOf(' - ');
    if (idx === -1) return { prefixo: null, acao: nome };
    return { prefixo: nome.substring(0, idx), acao: nome.substring(idx + 3) };
  }

  getSelectedRoles(): Array<PermissaoStruct> {
    let permissoesSelecionadas: Array<PermissaoStruct> = new Array<PermissaoStruct>();
    this.listaModuloPerfil.forEach(modulo => {
      modulo.listaFuncionalidade.forEach(funcionalidade => {
        const selected = funcionalidade.listaPermissao.filter(permissao => permissao.selecionado);
        permissoesSelecionadas = permissoesSelecionadas.concat(selected);
      });
    });

    return permissoesSelecionadas;
  }

  setProfileRoles(rolesList: Array<number>): void {
    this.listaModuloPerfil.forEach((module: ModuloPerfilStruct) => {
      module.listaFuncionalidade.forEach(funcionalidade => {
        funcionalidade.listaPermissao.forEach((permissao: PermissaoStruct) => {
          permissao.selecionado = rolesList.indexOf(permissao.idPermissao) > -1;
        });
      });
    });
  }

  populateProfileData(): void {
    this.perfilService.ObterPorId(this.idPerfil).subscribe({
      next: response => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this._isLoading = false;
          this.isFirstLoading = false;
          return;
        }

        this.setProfileRoles(response.listaIdPermissao);
        this.model.setValue({
          nome: response.nomePerfil,
          descricao: response.descricao,
        });

        // Populate IP restrictions
        this.listaIpRestrito = response.listaIpRestrito?.map(ip => ip.trim()).filter(ip => ip.length > 0) ?? [];

        // Populate schedule restrictions
        // Reset to defaults (disabled + a single editable interval template)
        // When backend has data, we replace interval lists per day.
        this.listaHorarioPorDia.forEach(d => {
          d.habilitado = false;
          d.intervalos = [{ horaInicio: '08:00', horaFim: '18:00' }];
        });

        if (response.listaAcessoHorario?.length) {
          response.listaAcessoHorario.forEach(horario => {
            const dia = this.listaHorarioPorDia.find(d => d.diaSemana === horario.diaSemana);
            if (dia) {
              if (!dia.habilitado) {
                dia.habilitado = true;
                dia.intervalos = [];
              }
              dia.intervalos.push({
                horaInicio: this.normalizeTime(horario.horaInicio),
                horaFim: this.normalizeTime(horario.horaFim),
              });
            }
          });
        }

        this.isFirstLoading = false;
      },
      error: error => {
        console.log(error);
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  listModule(): void {
    this.moduloPerfilService.get().subscribe({
      next: (response: ListaModuloPerfilResponse) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this._isLoading = false;
          return;
        }

        this.listaModuloPerfil = response.listaModuloPerfil;

        if (this.idPerfil) {
          this.isFirstLoading = true;
          this.isUpdate = true;
          this.populateProfileData();
        }
      },
      error: error => {
        console.log(error);
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  openModal(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Caro Usuário',
        innerHtml: `<p>Esta funcionalidade não esta disponível em sua conta.<br />Fale com o consultor e veja o que é necessário para ativá-la cliando <a href="https://www.atsinformatica.com.br"
        target="_blank">aqui</a>.</p>`,
        buttonConfirm: 'Saiba mais',
        buttonClose: 'Fechar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          window.open('https://www.atsinformatica.com.br', '_blank');
        }
      },
    });
  }

  cancelar(): void {
    this.router.navigate(['/configuracoes/perfil']);
  }
}
